<template>
  <v-container>
    <H1>{{$t('home.WELCOME')}}</H1>
    <br>
    <p>{{$t('home.DESCRIPTION')}}</p>
    <br>
    <v-card class="mx-auto" max-width="344" outlined>
        <v-card-title>{{$t('home.INFO_CARD_HEADER')}}</v-card-title>
        <v-card-text v-html="$t('home.INFO_CARD_BODY')"></v-card-text>
        <v-card-actions>
            <v-btn :loading="loading" width="100%" @click="loading = true" to="/flarmcfg">
                {{$t('home.INFO_CARD_BTN')}}
            </v-btn>
        </v-card-actions>
    </v-card>
  </v-container>
</template>

<style>
.v-card__text, .v-card__title {
  word-break: normal;
}
</style>

<script>
export default {
  data() {
    return {
      loading: false
    }
  }
}
</script>